// HalfYearlyReport.jsx
import React, { useState } from "react";
import { Table, Modal, Button } from "react-bootstrap";
import { useParams } from "react-router-dom";
import Preloader from "../../shared/PreLoaders";

import {
  handleExportAllFormats,
  handleExportSingleFormat,
} from "../../utils/exportToExcel";
const formats = [
  "Format-I",
  "Format-II",
  "Format-III",
  "Format-IIIA",
  "Format-IV",
];

const HalfYearlyReport = () => {
  const [selectedFormat, setSelectedFormat] = useState(null);
  const { year } = useParams();
  const [showModal, setShowModal] = useState(true);
  const [reportData, setReportData] = useState([]);
  const Api = process.env.REACT_APP_API;
  const [selectedHalfYear, setSelectedHalfYear] = useState(null);
  const [showHalfYearModal, setShowHalfYearModal] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSelect = async (format) => {
    setSelectedFormat(format);
    setShowModal(false);
    setShowHalfYearModal(true); // trigger second modal
  };
  const fetchReport = async (halfYear) => {
    setSelectedHalfYear(halfYear);
    setShowHalfYearModal(false);
    setLoading(true); // Start loading
    try {
      const response = await fetch(`${Api}/api/half-yearly-report/filter`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          format: selectedFormat,
          year: year,
          half: halfYear,
        }),
      });

      const data = await response.json();
      setReportData(data);
    } catch (error) {
      console.error("Error fetching report data:", error);
      setReportData([]);
    } finally {
      setLoading(false); // Stop loading
    }
  };

  const renderFormat = () => {
    switch (selectedFormat) {
      case "Format-I":
        return (
          <div className="card mt-4">
            <div className="card-body">
              <div className="row icons-list">
                <div className="text-end mb-2">
                  <button
                    type="button"
                    className="btn btn-outline-success btn-icon-text mt-3"
                    onClick={() => {
                      const data = allReportsByFormat[selectedFormat];
                      handleExportSingleFormat(
                        selectedFormat,
                        data, // <--- this is already the data
                        year,
                        selectedHalfYear
                      );
                    }}
                  >
                    <i className="mdi mdi-file-excel"></i> Export to Excel
                  </button>
                </div>
                <div className="table-responsive">
                  <Table className="border mt-3">
                    <thead>
                      <tr>
                        <th>Name of the Division</th>
                        <th>Name of the District</th>
                        <th>Year</th>
                        <th>Name of the Project Village</th>
                      </tr>
                    </thead>
                    <tbody>
                      {reportData.length > 0 ? (
                        reportData.map((report, index) => (
                          <tr key={index}>
                            <td>
                              {report.formatI?.nameOfDivision?.divisionName ||
                                "—"}
                            </td>
                            <td>{report.formatI?.nameOfDistrict || "—"}</td>
                            <td>{report.formatI?.year || "—"}</td>
                            <td>
                              {report.formatI?.nameOfProjectVillage?.vfcName ||
                                "—"}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="4" className="text-center py-2">
                            No data available
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </div>
              </div>
            </div>
          </div>
        );

      case "Format-II":
        return (
          <div className="card mt-4">
            <div className="card-body">
              <div className="row icons-list">
                <div className="table-responsive">
                  <Table className="border mt-3">
                    <thead>
                      <tr>
                        <th>Year</th>

                        <th>Name of The Division </th>
                        <th>
                          Physical Target <br /> (in Ha./Km)
                        </th>
                        <th>
                          Achievement <br /> (in Ha./Km)
                        </th>
                        <th>
                          Financial Target <br /> (Rs. in Lakhs)
                        </th>
                        <th>
                          Achievement <br /> (in Ha./Km)
                        </th>
                        <th>
                          Dates of Meeting <br />
                          Held Between
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {reportData.length > 0 ? (
                        reportData.map((report, index) => (
                          <tr key={index}>
                            <td>{report.formatII?.year || "—"}</td>
                            <td>
                              {report.formatII?.nameOfDivision?.divisionName ||
                                "—"}
                            </td>
                            <td>{report.formatII?.physicalTarget || "—"}</td>
                            <td>{report.formatII?.achievement || "—"}</td>
                            <td>{report.formatII?.financialTarget || "—"}</td>
                            <td>
                              {report.formatII?.financialAchievement || "—"}
                            </td>
                            <td>{report.formatII?.meetingDates || "—"}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="3" className="text-center py-2">
                            No data available
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </div>
              </div>
            </div>
          </div>
        );

      case "Format-III":
        return (
          <div className="card mt-4">
            <div className="card-body">
              <div className="row icons-list">
                <div className="table-responsive">
                  <Table className="border mt-3">
                    <thead>
                      <tr>
                        <th>Name of The Division</th>
                        <th>Year</th>
                        <th>Name of the TAP Village</th>
                        <th>Name of the Work Done</th>
                        <th>Name of the Department Involved</th>
                        <th>Amount Spent By the Line Dept. (in Lakhs)</th>
                      </tr>
                    </thead>
                    <tbody>
                      {reportData.length > 0 ? (
                        reportData.map((report, reportIndex) =>
                          report.formatIII?.map((entry, i) => (
                            <tr key={`${reportIndex}-${i}`}>
                              <td>
                                {entry.nameOfDivision?.divisionName || "—"}
                              </td>
                              <td>{entry.year || "—"}</td>
                              <td>{entry.nametapVillage?.vfcName || "—"}</td>
                              <td>{entry.workDone || "—"}</td>
                              <td>{entry.departmentInvolved || "—"}</td>
                              <td>{entry.amountSpent ?? "—"}</td>
                            </tr>
                          ))
                        )
                      ) : (
                        <tr>
                          <td colSpan="6" className="text-center py-2">
                            No data available
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </div>
              </div>
            </div>
          </div>
        );

      case "Format-IIIA":
        return (
          <div className="card mt-4">
            <div className="card-body">
              <div className="row icons-list">
                <div className="table-responsive">
                  <Table className=" border mt-3">
                    <thead>
                      <tr>
                        <th rowSpan="2">Name of the Division</th>
                        <th rowSpan="2">Year</th>
                        <th rowSpan="2">Name of the TAP Village</th>
                        <th rowSpan="2">No. of Medical Camp Held</th>
                        <th colSpan="3">No. of Persons Benefited</th>
                        <th rowSpan="2">Name of the Department Involved</th>
                        <th rowSpan="2">No. of Veterinary Camps Held</th>
                        <th rowSpan="2">No. of Cattle Benefited</th>
                        <th rowSpan="2">Name of Line Department Involved</th>
                      </tr>
                      <tr>
                        <th>Male</th>
                        <th>Female</th>
                        <th>Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      {reportData.length > 0 ? (
                        reportData.map((report, i) =>
                          report.formatIIIA?.map((item, j) => (
                            <tr key={`${i}-${j}`}>
                              <td>
                                {item.nameOfDivision?.divisionName || "—"}
                              </td>
                              <td>{item.year || "—"}</td>
                              <td>{item.nametapVillage?.vfcName || "—"}</td>
                              <td>{item.medicalCampCount ?? "—"}</td>
                              <td>{item.beneficiariesMale ?? "—"}</td>
                              <td>{item.beneficiariesFemale ?? "—"}</td>
                              <td>{item.beneficiariesTotal ?? "—"}</td>
                              <td>{item.departmentInvolved || "—"}</td>
                              <td>{item.vetCampsHeld ?? "—"}</td>
                              <td>{item.cattleBenefited ?? "—"}</td>
                              <td>{item.lineDepartmentInvolved || "—"}</td>
                            </tr>
                          ))
                        )
                      ) : (
                        <tr>
                          <td colSpan="11" className="text-center py-2">
                            No data available
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </div>
              </div>
            </div>
          </div>
        );

      case "Format-IV":
        return (
          <div className="card mt-4">
            <div className="card-body">
              <div className="row icons-list">
                <div className="table-responsive">
                  <Table className="border mt-3">
                    <thead>
                      <tr>
                        <th>Name of Division</th>
                        <th>Year</th>
                        <th>Name of the TAP Village</th>
                        <th>Panchayat</th>
                        <th>Work Pending</th>
                        <th>Reason for Delay</th>
                        <th>Amount (in Lakhs)</th>
                        <th>Order Awaited From Department</th>
                      </tr>
                    </thead>
                    <tbody>
                      {reportData.length > 0 ? (
                        reportData.map((report, reportIndex) =>
                          report.formatIV?.map((entry, i) => (
                            <tr key={`${reportIndex}-${i}`}>
                              <td>
                                {entry.nameOfDivision?.divisionName || "—"}
                              </td>
                              <td>{entry.year || "—"}</td>
                              <td>{entry.nametapVillage?.vfcName || "—"}</td>
                              <td>{entry.panchayat || "—"}</td>
                              <td>{entry.workPending || "—"}</td>
                              <td>{entry.reasonForDelay || "—"}</td>
                              <td>{entry.amount ?? "—"}</td>
                              <td>{entry.orderAwaitedFromDept || "—"}</td>
                            </tr>
                          ))
                        )
                      ) : (
                        <tr>
                          <td colSpan="8" className="text-center py-2">
                            No data available
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </div>
              </div>
            </div>
          </div>
        );

      default:
        return null;
    }
  };
  const allReportsByFormat = {
    "Format-I": reportData.map((r) => r.formatI).filter(Boolean),
    "Format-II": reportData.map((r) => r.formatII).filter(Boolean),
    "Format-III": reportData.flatMap((r) => r.formatIII || []),
    "Format-IIIA": reportData.flatMap((r) => r.formatIIIA || []),
    "Format-IV": reportData.flatMap((r) => r.formatIV || []),
  };

  return (
    <div className="p-4">
      <h2 className="text-xl font-semibold mb-4">
        Half-Yearly Progress Report
      </h2>
      <div className="text-end mb-2">
        <button
          type="button"
          className="btn btn-outline-success btn-icon-text mt-3"
          onClick={() =>
            handleExportAllFormats(allReportsByFormat, year, selectedHalfYear)
          }
        >
          <i className="mdi mdi-file-excel"></i> Export All Format To Excel
        </button>
      </div>
      {selectedFormat && selectedHalfYear && (
        <h5 className="mb-3 text-muted">
          Showing <strong>{selectedFormat}</strong> for{" "}
          <strong>
            {selectedHalfYear === "H1" ? "January – June" : "July – December"}
          </strong>{" "}
          ({year})
        </h5>
      )}
      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Select Report Format</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {formats.map((format) => (
            <Button
              key={format}
              variant="outline-primary"
              className="w-100 mb-2"
              onClick={() => handleSelect(format)}
            >
              {format}
            </Button>
          ))}
        </Modal.Body>
      </Modal>
      <Modal
        show={showHalfYearModal}
        onHide={() => setShowHalfYearModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Select Half-Year</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Button
            variant="outline-primary"
            className="w-100 mb-2"
            onClick={() => fetchReport("H1")}
          >
            Jan – Jun (H1)
          </Button>
          <Button
            variant="outline-primary"
            className="w-100"
            onClick={() => fetchReport("H2")}
          >
            Jul – Dec (H2)
          </Button>
        </Modal.Body>
      </Modal>

      {loading ? <Preloader loading={loading} /> : renderFormat()}
    </div>
  );
};

export default HalfYearlyReport;
